/* Project Import will be here */
import Constants from "../utilities/appConstants";
/* Project Import will be here */

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem(Constants.LcKey);

    /* !serializedState.startsWith("{") - this condition is added to test the "uncaught syntaxerror: unexpected token '<'" issue. 
    This fix given for experimental now, if it solves the issue in QA then will consider as actual fix  */
    if (serializedState === null || !serializedState.startsWith("{")) {
      /* If local store data not available return undefined */
      return undefined;
    }

    /* Else parse the local store data and send */
    return JSON.parse(serializedState);
  }
  catch (err) {
    return undefined;
  }
};

export const saveState = state => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(Constants.LcKey, serializedState);
  }
  catch (err) {
    /* Ignore write errors. */
  }
};


/* Payment request capture */
export const setIsPaymentRequested = (value: boolean) => {
  try {
    localStorage.setItem(Constants.PAYMENT_REQUESTED, value);
  }
  catch (err) {
    /* Ignore write errors. */
  }
}

export const getIsPaymentRequested = () => {
  const isPaymentRequested = localStorage.getItem(Constants.PAYMENT_REQUESTED);

  if (isPaymentRequested !== null)
    return isPaymentRequested === 'true';
  else
    return undefined;
}